interface SourceBreadcrumbProps {
  label: string;
  root?: string;
}

export function SourceBreadcrumb({ label, root = 'Sources' }: SourceBreadcrumbProps) {
  return <div className='px-4 pt-3 text-xs text-muted-foreground'>{root} / {label}</div>;
}
